import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LOADING } from 'store';
import { useTranslation } from 'react-i18next';
import FileUploadMultiple, { File } from 'components/FileUploadMultiple';
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Spinner
} from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import DatePicker from 'react-datepicker';
import Currency, { currencyReverse, DollarCurrency, EuroCurrency,
  CurrencyPlainText,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText } from 'helpers/Currency';
import { api } from 'services';
import { toast } from 'react-toastify';
import arrayAppend from 'helpers/array-append';
import { formatDate, parseDate } from 'helpers/date';
import style from './style.module.scss';
import PadLock from 'components/PadLock';

const ActionsFormRefunds = ({
  loading,
  actionId,
  refunds,
  setRefunds,
  editable,
  currency
}) => {
  const [showModal, setShowModal] = useState(false);

  const [id, setId] = useState('');
  const [refundTypeId, setRefundTypeId] = useState('');
  const [receivingDate, setReceivingDate] = useState('');
  const [value, setValue] = useState('');
  const [observation, setObservation] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [types, setTypes] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoad, setLoad] = useState(false);

  const { t } = useTranslation();
  let dialog;

  useEffect(() => {
    api.get('refund-types').then(({ data }) => setTypes(data));
  }, []);

  useEffect(() => {
    var sum = 0;
    refunds.forEach(refund => (sum += refund.value));
    setTotal(sum);
  }, [refunds]);

  const handleEdit = k => {
    const refund = refunds[k];
    setId(refund.id);
    setRefundTypeId(refund.refund_type_id);
    setReceivingDate(refund.receiving_date);
    setValue(refund.value);
    setObservation(refund.observation);

    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
    setId('');
    setRefundTypeId('');
    setReceivingDate('');
    setValue('');
    setObservation('');
    setFiles([]);
    setFilesComments([]);
  };

  const deleteRefund = k => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger'
    });

    dialog.show({
      title: t('title:refunds delete'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          loading(true);
          api.delete(`refunds/${refunds[k].id}`).then(() => {
            loading(false);
            refreshRefunds();
            toast.success('Deletado com sucesso!');
          });
        })
      ],
      bgSize: 'small'
    });
  };

  const handleSave = () => {
    loading(true);
    setLoad(true);
    const formData = new FormData();

    toast.dismiss();

    if (!!id) formData.append('_method', 'put');

    formData.append('action_id', actionId);
    formData.append('refund_type_id', refundTypeId);
    formData.append('receiving_date', formatDate(receivingDate));
    formData.append('value', currencyReverse(value));
    formData.append('observation', observation);

    arrayAppend(formData, 'file', files);
    arrayAppend(formData, 'files_comments', filesComments);

    api
      .post(!!id ? `refunds/${id}` : 'refunds', formData, {
        headers: {
          'X-Success-Message': t('alerts:info_refund_inserted'),
          'X-Show-Alert': true
        }
      })
      .then(() => {
        handleHideModal();
        refreshRefunds();
      })
      .finally(() => loading(false) && setLoad(false))
      .catch(() => loading(false) && setLoad(false));
  };

  const getCurrencyTagDisabled = (value) => {
    switch (currency) {
      case '1':
        return <Currency value={value} disabled />;
        break;
      case '2':
        return <DollarCurrency value={value} disabled />;
        break;
      case '3':
        return <EuroCurrency value={value} disabled />;
        break;
      default:
        break;
    }
  }

  const getCurrencyTag = (value) => {
    switch (currency) {
      case '1':
        return <Currency value={value} onChange={e => setValue(e.target.value)} />;
        break;
      case '2':
        return <DollarCurrency value={value} onChange={e => setValue(e.target.value)} />;
        break;
      case '3':
        return <EuroCurrency value={value} onChange={e => setValue(e.target.value)} />;
        break;
      default:
        break;
    }
  }

  const refreshRefunds = () => {
    return api.get(`actions/${actionId}/refunds`).then(({ data }) =>
      setRefunds(
        data.map(refund => {
          return {
            ...refund,
            ...{
              receiving_date: new Date(parseDate(refund.receiving_date)),
              hidden: true
            }
          };
        })
      )
    );
  };

  const setHidden = (value, k) => {
    const updateArray = [...refunds];
    updateArray[k].hidden = value;
    setRefunds(updateArray);
  };

  if (!actionId) return <></>;

  return (
    <>
      <Modal size="lg" show={showModal} onHide={handleHideModal}>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:receiving date')}</Form.Label>
                <DatePicker
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  locale="pt_BR"
                  selected={receivingDate}
                  onChange={date => setReceivingDate(date)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')}</Form.Label>
                {/* <Currency
                  value={value}
                  onChange={e => setValue(e.target.value)}
                /> */}
                {getCurrencyTag(value)}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:type')}</Form.Label>
                <Form.Control
                  as="select"
                  value={refundTypeId}
                  onChange={e => setRefundTypeId(e.target.value)}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  {types.map((type, k) => (
                    <option key={k} value={type.id}>
                      {t(`label:${type.name}`)}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <FileUploadMultiple
                files={files}
                setFiles={files => setFiles(files)}
                filesComments={filesComments}
                setFilesComments={filesComments =>
                  setFilesComments(filesComments)
                }
                existingFiles={[]}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:observation')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  value={observation}
                  onChange={e => setObservation(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleHideModal}>
            {t('label:cancel')}
          </Button>
          {isLoad ? (
            <Row className="float-right text-right">
              <Spinner animation="border" style={{ color: '#e05c17' }} />
              <h6 className="m-2">Salvando...</h6>
            </Row>
          ) : (
              <Button size="sm" onClick={handleSave}>
                {t('label:save')}
              </Button>
            )}
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={component => {
          dialog = component;
        }}
      />
      <Row className="mt-2">
        <Col>
          {!editable ? <PadLock /> : null}
          <Row>
            <Col>
              <h4>{t('title:refund information')}</h4>
            </Col>
          </Row>
          {refunds.map((refund, k) => (
            <Row key={k} className="mt-2">
              <Col
                className={`${style.refund} ${
                  refund.hidden ? style.hidden : null
                  }`}
              >
                {refund.hidden ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{t('label:expand')}</Tooltip>}
                  >
                    <i
                      className="refundIcon fas fa-plus"
                      onClick={() => setHidden(false, k)}
                    />
                  </OverlayTrigger>
                ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{t('label:minimize')}</Tooltip>}
                    >
                      <i
                        className="refundIcon fas fa-minus"
                        onClick={() => setHidden(true, k)}
                      />
                    </OverlayTrigger>
                  )}
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:delivery date')}</Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={refund.receiving_date}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:value')}</Form.Label>
                      {/* <Currency value={refund.value} disabled /> */}
                      {getCurrencyTagDisabled(refund.value)}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:type')}</Form.Label>
                      <Form.Control
                        as="select"
                        value={refund.refund_type_id}
                        tabIndex="-1"
                        style={{
                          background: '#eee',
                          pointerEvents: 'none',
                          touchAction: 'none'
                        }}
                      >
                        <option disabled value="">
                          {t('label:select')}
                        </option>
                        {types.map((type, k) => (
                          <option key={k} value={type.id}>
                            {t(`label:${type.name}`)}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:brief description')}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        value={refund.observation}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {refund.files.map((file, k) => (
                      <File
                        key={k}
                        extension={file.extension}
                        comment={file.comment}
                        uri={file.uri}
                      />
                    ))}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => handleEdit(k)}
                      disabled={!editable}
                    >
                      {t('label:edit')}
                    </Button>
                    &nbsp;
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => deleteRefund(k)}
                      disabled={!editable}
                    >
                      <i className="fas fa-trash" />
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
          <Row className="mt-2 mb-4">
            <Col>
              <Button
                size="sm"
                variant="dark"
                onClick={() => setShowModal(true)}
                disabled={!editable}
              >
                <i className="fas fa-plus" /> {t('label:add new')}
              </Button>
            </Col>
            <Col className="mt-2 text-right">
              <b>Total:</b>{' '}
              {
              (currency==='1'?'R$ ':(currency==='2'?'$ ':'€ '))+
              parseFloat(total.toFixed(2)).toLocaleString(currency==='2'?'en':'pt')+
              (total % 1 === 0?(currency==='2'?'.':',')+'00':'')
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  loading: payload => dispatch({ type: LOADING, payload })
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionsFormRefunds);
